function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useReducer } from "react";
import { parse } from "query-string";
import { parseFilter } from "../../utils";
import Widget from '../Widget/Widget';
import { Dropdown, RegularButton, CustomInputMask } from "../inputs";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./Filters.module.sass";
import filterOperators from './filterOperators.json';

const reducer = (state, action) => {
  const result = JSON.parse(JSON.stringify(state));
  result.lastUpdate = Date.now();

  switch (action.type) {
    case "update":
      if (action.indexes.length === 1) {
        result[action.indexes[0]] = { ...(result[action.indexes[0]] || {}),
          ...action.payload,
          filters: (result[action.indexes[0]] || {}).column === action.payload.column ? (result[action.indexes[0]] || {}).filters : [{
            value: ""
          }],
          operator: ""
        };
      } else if (action.indexes.length === 2) {
        const filterEntry = result[action.indexes[0]] || {
          filters: []
        };
        filterEntry.filters[action.indexes[1]] = { ...(filterEntry.filters[action.indexes[1]] || {}),
          ...action.payload
        };
        result[action.indexes[0]] = filterEntry;
      }

      return result;

    case "add":
      if (action.index !== undefined && action.operator === "and") {
        result.splice(action.index + 1, 0, {
          filters: [{
            value: ""
          }]
        });
      } else if (action.index !== undefined && action.operator === "or") {
        result[action.index].filters.push({
          value: ""
        });
      }

      return result;

    case "delete":
      if (action.indexes.length === 1) {
        result.splice(action.indexes[0], 1);
      } else if (action.indexes.length === 2) {
        (result[action.indexes[0]].filters || []).splice(action.indexes[1], 1);
      }

      return result;

    case "reset":
      const resetResult = action.payload ? action.payload : [{
        filters: [{
          value: ""
        }]
      }];
      resetResult.lastUpdate = Date.now();
      return resetResult;

    case "updateOperator":
      result[action.indexes[0]].operator = action.payload.value;
      return result;

    default:
      return result;
  }
};

const keyPressHandler = e => {
  //? the key 13 equals to Enter
  if (e.keyCode == 13) {
    document.getElementById("applyFilterButton").click();
  }
};

const renderInputs = (type, values, list, listMapper, operator, disableOperators, indexes, dispatch, i18n, mask, state) => {
  const valuesArray = (values || "").split("#").map(v => listMapper && listMapper[v] ? listMapper[v] : v);
  const autocomplete = list && list.length;
  const Input = !autocomplete || operator && ["like", "not like", "starts with", "not starts with"].includes(operator) ? "input" : Dropdown;
  const inputProps = autocomplete ? {
    highlightSelection: true
  } : {};
  const defaultFilter = {
    "id": "equals",
    "name": "equals"
  };
  const options = autocomplete ? list.map(item => {
    if (typeof item !== "object") {
      return {
        id: item,
        name: listMapper && listMapper[item] ? listMapper[item] : item
      };
    }

    return item;
  }) : null;

  switch (type.toLowerCase()) {
    case "int":
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? "" : /*#__PURE__*/React.createElement(Dropdown, {
          className: styles['dropdown'],
          value: operator || defaultFilter,
          options: filterOperators[`${type.toLowerCase()}`],
          placeholder: i18n`-- select an operator --`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${value}`
              }
            });
          }
        }), operator === 'between' || operator === 'not between' || disableOperators ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
          className: autocomplete ? styles["dropdown"] : styles["input"],
          value: valuesArray[0] || "",
          options: options,
          placeholder: autocomplete ? i18n`-- From value --` : i18n`From value`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${value}${valuesArray[1] && valuesArray[1].length ? `#${valuesArray[1]}` : ""}`
              }
            });
          }
        })), /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
          className: autocomplete ? styles["dropdown"] : styles["input"],
          value: valuesArray[1] || "",
          options: options,
          placeholder: autocomplete ? i18n`-- To value --` : i18n`To value`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${valuesArray[0] || 0}#${value}`
              }
            });
          }
        }))) : operator === 'is null' || operator === 'is not null' || disableOperators ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(Input, {
          className: autocomplete ? styles["dropdown"] : styles["input"],
          placeholder: '',
          value: valuesArray[0] || "",
          options: options,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: value
              }
            });
          }
        }));
      }

    case "date":
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? "" : /*#__PURE__*/React.createElement(Dropdown, {
          className: styles['dropdown'],
          value: operator || defaultFilter,
          options: filterOperators[`${type.toLowerCase()}`],
          placeholder: i18n`-- select an operator --`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${value}`
              }
            });
          }
        }), operator === 'between' || operator === 'not between' || disableOperators ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomInputMask, {
          className: autocomplete ? styles["dropdown"] : styles["inputs-container"],
          placeholder: mask.toUpperCase(),
          value: valuesArray[0] || "",
          options: options,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${value}${valuesArray[1] && valuesArray[1].length ? `#${valuesArray[1]}` : ""}`
              }
            });
          }
        }), /*#__PURE__*/React.createElement(CustomInputMask, {
          className: autocomplete ? styles["dropdown"] : styles["inputs-container"],
          placeholder: mask.toUpperCase(),
          value: valuesArray[1] || "",
          options: options,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${valuesArray[0] || " "}#${value}`
              }
            });
          }
        })) : operator === 'is null' || operator === 'is not null' || disableOperators ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(CustomInputMask, {
          className: autocomplete ? styles["dropdown"] : styles["inputs-container"],
          placeholder: mask.toUpperCase(),
          value: valuesArray[0] || "",
          options: options,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: value
              }
            });
          }
        }));
      }

    case "autosearch":
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? "" : /*#__PURE__*/React.createElement(Dropdown, {
          className: styles['dropdown'],
          value: operator || defaultFilter,
          options: filterOperators["string"],
          placeholder: i18n`-- select an operator --`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${value}${valuesArray[1] && valuesArray[1].length ? `-${valuesArray[1]}` : ""}`
              }
            });
          }
        }), operator === 'is null' || operator === 'is not null' ? /*#__PURE__*/React.createElement("div", null) : ["like", "not like", "starts with", "not starts with"].includes(operator) ? /*#__PURE__*/React.createElement(Input, {
          className: styles["input"],
          placeholder: '',
          value: valuesArray[0] || "",
          options: options,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: value
              }
            });
          }
        }) : /*#__PURE__*/React.createElement(Dropdown, {
          className: styles['dropdown'],
          placeholder: '',
          value: valuesArray[0] || "",
          options: options,
          filter: true,
          required: true,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: value
              }
            });
          }
        }));
      }

    default:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? "" : /*#__PURE__*/React.createElement(Dropdown, {
          className: styles['dropdown'],
          value: operator || defaultFilter,
          options: filterOperators["string"],
          placeholder: i18n`-- select an operator --`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${value}${valuesArray[1] && valuesArray[1].length ? `-${valuesArray[1]}` : ""}`
              }
            });
          }
        }), operator === 'is null' || operator === 'is not null' ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, {
          className: !autocomplete || ["like", "not like", "starts with", "not starts with"].includes(operator) ? styles["input"] : styles["dropdown"],
          value: valuesArray[0] || "",
          options: options,
          placeholder: !autocomplete && i18n`Type a filter value`,
          onKeyDown: e => keyPressHandler(e),
          onChange: e => {
            const value = e.target.value.id ? e.target.value.id : e.target.value;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: value
              }
            });
          }
        })));
      }
  }
};

const renderFilters = (state, availableFilters, dispatch, i18n) => {
  const usedColumns = new Set();
  state.forEach(({
    column
  }) => {
    if (column !== undefined) {
      usedColumns.add(column);
    }
  });
  return state.map((filterEntry, index) => {
    const {
      column,
      filters,
      operator
    } = filterEntry;
    const options = availableFilters.filter(({
      prop
    }) => prop === column || !usedColumns.has(prop)).map(({
      prop,
      type,
      name,
      list,
      listMapper,
      disableOperators = false,
      mandatory = false,
      mask
    }) => ({
      id: prop,
      name: name || prop,
      type,
      list,
      listMapper,
      disableOperators,
      mandatory,
      mask
    }));
    const currentOption = options.find(({
      id
    }) => id === column);
    const type = (currentOption || {}).type;
    const filterValue = ((filters || [])[0] || {}).value;
    const innerFilters = (filters || []).slice(1);
    const otherFilters = innerFilters.map((innerFilter, innerIndex) => /*#__PURE__*/React.createElement("div", {
      key: innerIndex,
      className: styles["inner-filter-entry"]
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["filter-entry-input"]
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["inputs-container"]
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles["operator"]
    }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, i18n`OR`))), /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, (currentOption || {}).name))), /*#__PURE__*/React.createElement("div", {
      className: styles["values-inputs"]
    }, type && renderInputs(type, innerFilter.value, currentOption.list, currentOption.listMapper, operator, currentOption.disableOperators, [index, innerIndex + 1], dispatch, i18n, currentOption.mask || "dd/mm/yyyy"))), /*#__PURE__*/React.createElement("div", {
      className: styles["actions"]
    }, /*#__PURE__*/React.createElement(RegularButton, {
      className: styles["delete"],
      danger: true,
      icon: "remove",
      onClick: () => {
        dispatch({
          type: "delete",
          indexes: [index, innerIndex + 1]
        });
      }
    })))));
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles["filter-entry"]
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["filter-entry-input"]
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["operator"]
    }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, index === 0 ? i18n`SELECT` : i18n`AND`))), /*#__PURE__*/React.createElement("div", {
      className: styles["inputs-container"]
    }, /*#__PURE__*/React.createElement(Dropdown, {
      highlightSelection: true,
      className: styles["dropdown"],
      placeholder: i18n`-- Select a column --`,
      value: currentOption,
      options: options,
      onChange: e => {
        dispatch({
          type: "update",
          indexes: [index],
          payload: {
            column: e.target.value.id
          }
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: styles["values-inputs"]
    }, type && renderInputs(type, filterValue, currentOption.list, currentOption.listMapper, operator, currentOption.disableOperators, [index, 0], dispatch, i18n, currentOption.mask || "dd/mm/yyyy", state))), /*#__PURE__*/React.createElement("div", {
      className: styles["actions"]
    }, index === state.length - 1 && state.length < availableFilters.length ? /*#__PURE__*/React.createElement(RegularButton, {
      onClick: () => {
        dispatch({
          type: "add",
          operator: "and",
          index
        });
      }
    }, i18n`AND`) : null, /*#__PURE__*/React.createElement(RegularButton, {
      onClick: () => {
        dispatch({
          type: "add",
          operator: "or",
          index
        });
      }
    }, i18n`OR`), state.length > 1 ? /*#__PURE__*/React.createElement(RegularButton, {
      className: styles["delete"],
      icon: "remove",
      danger: true,
      onClick: () => {
        dispatch({
          type: "delete",
          indexes: [index]
        });
      }
    }) : null)), otherFilters);
  });
};

const Filters = props => {
  const {
    modifiers,
    filter,
    availableFilters,
    anchor,
    expanded = true
  } = props;
  const {
    i18n,
    history,
    location,
    goto
  } = useGlobalValue();
  const filtersObj = filter ? parseFilter(filter) : null;
  const [state, dispatch] = useReducer(reducer, filtersObj || [{
    filters: [{
      value: ""
    }]
  }]);

  const removeFilter = () => {
    dispatch({
      type: "reset"
    });
    goto && goto(null, undefined);
  };

  const updateFilter = value => {
    goto && goto(null, value, anchor);
  };

  useEffect(() => {
    dispatch({
      type: "reset",
      payload: filtersObj && filtersObj.length ? filtersObj : [{
        filters: [{
          value: ""
        }]
      }]
    });
  }, [location.pathname]);
  useEffect(() => {
    const searchParams = parse(location.search);

    if (searchParams.resetFilters !== undefined && Number(searchParams.resetFilters) > (state.lastUpdate || 0)) {
      dispatch({
        type: "reset",
        payload: filtersObj && filtersObj.length ? filtersObj : [{
          filters: [{
            value: ""
          }]
        }]
      });
    }
  }, [filtersObj, state, location, history]);
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const hasMandatoryFields = (availableFilters || []).reduce((acc, elem) => {
    if (elem.mandatory === true) {
      acc.push(i18n`${elem.name}`);
    }

    return acc;
  }, []);
  const informationMessage = hasMandatoryFields.length > 0 ? i18n`There are some mandatory filters` + ` (${hasMandatoryFields.join(", ")})` : "";
  let hideFilters = false;
  let numberOfFilters;

  if (filtersObj !== null && filtersObj.length) {
    filtersObj.map(elem => {
      if (elem.filters.length >= 1) {
        hideFilters = true;
      }
    });
    numberOfFilters = filtersObj.length;
  }

  return availableFilters && availableFilters.length ? /*#__PURE__*/React.createElement(Widget, {
    modifiers: modifiers,
    title: !hideFilters ? i18n`Filters` : i18n`Filters (${numberOfFilters} Applied)`,
    displayInfo: informationMessage,
    setClose: hideFilters ? true : false
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${modifiersClasses}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["filters-container"]
  }, /*#__PURE__*/React.createElement("div", null, renderFilters(state, availableFilters || [], dispatch, i18n)), /*#__PURE__*/React.createElement("div", {
    className: styles["main-actions"]
  }, state && state.some(({
    column
  }) => column !== undefined) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RegularButton, {
    id: "clearFilterButton",
    onClick: removeFilter
  }, /*#__PURE__*/React.createElement("small", null, i18n`Clear filters`)), /*#__PURE__*/React.createElement(RegularButton, {
    id: "applyFilterButton",
    onClick: () => {
      updateFilter(state);
    }
  }, i18n`Apply filters`)) : null)))) : null;
};

export default Filters;